<template>
    <!-- 保單卡片 -->
    <Card
        :title="investmentObj.fullPolicyNo"
        :disabled="disabled"
        :cursor-pointer="!disabled"
        :tagText="investmentObj.memo"
    >
        <template #topContent>
            <div
                class="h4 py-2 px-2.5 font-medium pad:min-h-[4.375rem]"
                :class="disabled ? 'text-gray-200' :'text-gray-900'"
            >
                {{ investmentObj.itemName }}
            </div>
            <div class="py-1 px-2.5 flex items-center justify-between">
                <div class="h5 font-normal flex-shrink-0 card-title">
                    被保險人
                </div>
                <div class="h4 font-normal text-right card-data break-all">
                    {{ investmentObj.name }}
                </div>
            </div>
        </template>
        <template #foldContent>
            <div class="py-1 px-2.5 flex items-center justify-between">
                <div class="h5 font-normal flex-shrink-0 card-title">
                    契約狀況
                </div>
                <div class="h4 font-normal text-right card-data">
                    {{ investmentObj.cnctStatText }}
                </div>
            </div>
            <div class="py-1 px-2.5 flex items-center justify-between">
                <div class="h5 font-normal flex-shrink-0 card-title">
                    契約始期
                </div>
                <div class="h4 font-normal text-right card-data">
                    {{ investmentObj.effectDateTW }}
                </div>
            </div>
        </template>
        <template #bottomContent>
            <div
                v-if="route.name !== routeName.POLICY_BASIC"
                class="py-1 px-2.5 flex items-center justify-between"
            >
                <div class="h5 font-normal flex-shrink-0 card-title">
                    保單投資屬性類型
                </div>
                <div class="h4 font-normal text-right card-data min-h-[1.5rem] xs:min-h-[1.75rem]">
                    {{ investmentObj.investTypeText }}
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import routeName from '@/router/constant.js';
import { useRoute } from 'vue-router';
import Card from '@/components/card/CardPolicyBase.vue';

export default {
    components: {
        Card
    },
    props: {
        investmentObj: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    setup() {
        const route = useRoute();
        return {
            route,
            routeName,
        };
    },
};
</script>

<style lang="scss" scoped>
.policy-card {
    &:not(.disabled) {
        .card-title {
            @apply text-gray-400;
        }
        .card-data {
            @apply text-gray-700;
        }
    }
    &.disabled {
        .card-title,
        .card-data {
            @apply text-gray-200;
        }
    }
}
</style>
